export const SITE = {
  name: "Mohamad Hama",
  shortName: "M. Hama",
  role: "Freelance Web Developer",
  location: "Helsingborg, Sweden",
  experience: "+3 years",
  tagline:
    "I design and build websites that quietly do their job — for restaurants, schools, salons, brands and the people behind them.",
  email: "Mohamad.Hama1355@gmail.com",
  whatsappRaw: "0046790208513",
  whatsappDisplay: "+46 79 020 85 13",
  whatsappLink: "https://wa.me/46790208513",
  linkedin: "https://www.linkedin.com/in/mohamad-ali-hama/",
  companies: ["Alkompis", "NovaCode"],
};

export const SKILLS = [
  "React",
  "Next.js",
  "JavaScript",
  "TypeScript",
  "Tailwind CSS",
  "Framer Motion",
  "Node.js",
  "FastAPI",
  "MongoDB",
  "REST APIs",
  "Responsive Design",
  "Accessibility",
  "SEO",
  "WordPress",
  "Figma",
  "Git",
];

export const SERVICES = [
  {
    n: "01",
    title: "Business Websites",
    desc: "Restaurants, salons, driving schools, local services — fast, trustworthy sites that convert.",
  },
  {
    n: "02",
    title: "Landing Pages",
    desc: "Single-page, conversion-focused experiences for products, brands and campaigns.",
  },
  {
    n: "03",
    title: "Multilingual Sites",
    desc: "Websites that speak to your audience — across languages, cultures and devices.",
  },
  {
    n: "04",
    title: "Redesign & Rebuilds",
    desc: "Taking an outdated or slow site and rebuilding it with modern stack and clean design.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Mohamad understood exactly what our restaurant needed — warm, fast, and easy for guests to use. Bookings went up almost immediately.",
    name: "Restaurant Owner",
    role: "Hospitality Client",
  },
  {
    quote:
      "Working with Mohamad felt collaborative from day one. He shipped a multilingual site that finally represents our association the way we wanted.",
    name: "Board Member",
    role: "Cultural Association, Erfurt",
  },
  {
    quote:
      "Clean code, clean design, on time. He took our driving school online and turned it into our main source of new students.",
    name: "School Director",
    role: "Hamscho Fahrschule",
  },
  {
    quote:
      "Reliable, calm, detail-oriented. The kind of developer you want long term, not just for one project.",
    name: "Studio Owner",
    role: "Beauty & Wellness",
  },
];
